import * as PIXI from 'pixi.js';

export default class Point extends PIXI.Point {
    public clone(): Point {
        return new Point(this.x, this.y);
    }

    public normalize() {
        const d = Math.sqrt(this.x * this.x + this.y * this.y);

        if (d !== 0) {
            this.x = this.x / d;
            this.y = this.y / d;
        }
    }

    public copy(point: Point) {
        this.set(point.x, point.y);
    }
}

export function cubicBezier(
    t: number,
    p1: Point,
    p2: Point,
    p3: Point,
    p4: Point
): Point {
    const t1 = 1 - t;
    // prettier-ignore
    return new Point(
        t1*t1*t1*p1.x + 3*t1*t1*t*p2.x + 3*t1*t*t*p3.x + t*t*t*p4.x,
        t1*t1*t1*p1.y + 3*t1*t1*t*p2.y + 3*t1*t*t*p3.y + t*t*t*p4.y
    );
}
